import { normalizeTableKey } from './normalizeTableKey';

/** True when two table identifiers refer to the same logical table. */
export function tablesMatch(a: string, b: string): boolean {
  const left = a.trim();
  const right = b.trim();
  if (!left || !right) return false;
  if (left === right) return true;
  if (left.toLowerCase() === right.toLowerCase()) return true;
  return normalizeTableKey(left) === normalizeTableKey(right);
}
